// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vX55","right":"styles_right__30JmD"};